var common = {
  // 拼接数组内容
  jointContent(arr) {
    if (!arr || arr.length === 0) {
      return ''
    }
    var str = ''
    var ai = 0;
    arr.forEach(m => {
      if (ai !== 0) {
        str += `\n`
      }
      str += m.msg + (this.endWith(m.msg, '.') || this.endWith(m.msg, '。') ? '' : '。')
      ai++;
    });
    return str
  },
  endWith(v, s) {
    if (s === null || s === '' || v.length === 0 || s.length > v.length) {
      return false
    }
    if (v.substring(v.length - s.length) === s) {
      return true
    } else {
      return false
    }
  }

}
export default common
